export const categories = [
  {
    id: "xuexi-ziliao",
    name: "学习资料",
    icon: "ri-book-open-line",
    description: "涵盖各学科教材、考试真题、课程笔记、考研资料等学习资源",
    count: 128,
    image: "https://readdy.ai/api/search-image?query=Modern%20minimalist%20study%20desk%20with%20open%20textbooks%2C%20notebooks%2C%20pencils%2C%20warm%20natural%20light%2C%20clean%20white%20and%20cream%20background%2C%20soft%20shadows%2C%20editorial%20style%2C%20simple%20composition%2C%20soft%20ambient%20lighting&width=800&height=600&seq=cat-xuexi-01&orientation=landscape",
  },
  {
    id: "gongju-ruanjian",
    name: "工具软件",
    icon: "ri-tools-line",
    description: "精选各类效率工具、系统优化、开发工具、办公软件等实用程序",
    count: 96,
    image: "https://readdy.ai/api/search-image?query=Clean%20minimalist%20desktop%20with%20modern%20software%20interface%20screenshots%2C%20sleek%20laptop%20on%20white%20desk%2C%20soft%20warm%20natural%20lighting%2C%20cream%20and%20white%20background%2C%20editorial%20product%20photography%2C%20simple%20elegant%20composition&width=800&height=600&seq=cat-gongju-01&orientation=landscape",
  },
  {
    id: "yingyin-sucai",
    name: "影音素材",
    icon: "ri-film-line",
    description: "高品质视频素材、音频资源、音效包、背景音乐等多媒体内容",
    count: 85,
    image: "https://readdy.ai/api/search-image?query=Professional%20audio%20and%20video%20editing%20setup%20with%20headphones%2C%20sound%20wave%20visualization%2C%20film%20reels%2C%20clean%20cream%20background%2C%20warm%20ambient%20light%2C%20minimalist%20style%2C%20editorial%20photography&width=800&height=600&seq=cat-yingyin-01&orientation=landscape",
  },
  {
    id: "sheji-ziyuan",
    name: "设计资源",
    icon: "ri-palette-line",
    description: "UI模板、字体包、图标集、插画素材、PSD源文件等设计师必备资源",
    count: 112,
    image: "https://readdy.ai/api/search-image?query=Creative%20designer%20workspace%20with%20color%20palettes%2C%20typography%20samples%2C%20sketch%20mockups%2C%20clean%20white%20and%20cream%20background%2C%20warm%20soft%20lighting%2C%20minimalist%20editorial%20style%2C%20simple%20composition&width=800&height=600&seq=cat-sheji-01&orientation=landscape",
  },
  {
    id: "dianzi-shuji",
    name: "电子书籍",
    icon: "ri-book-3-line",
    description: "精选电子书、期刊杂志、技术文档、行业报告等数字阅读资源",
    count: 156,
    image: "https://readdy.ai/api/search-image?query=Elegant%20bookshelf%20with%20e-reader%20tablet%20displaying%20digital%20books%2C%20warm%20ambient%20light%2C%20clean%20cream%20and%20white%20background%2C%20minimalist%20style%2C%20soft%20natural%20shadows%2C%20editorial%20photography&width=800&height=600&seq=cat-shuji-01&orientation=landscape",
  },
  {
    id: "shiyong-moban",
    name: "实用模板",
    icon: "ri-file-list-3-line",
    description: "PPT模板、Word文档、Excel表格、简历模板等办公实用模板合集",
    count: 93,
    image: "https://readdy.ai/api/search-image?query=Modern%20office%20desk%20with%20printed%20document%20templates%2C%20neatly%20organized%20papers%2C%20warm%20cream%20background%2C%20soft%20natural%20lighting%2C%20minimalist%20style%2C%20clean%20editorial%20photography%2C%20simple%20composition&width=800&height=600&seq=cat-moban-01&orientation=landscape",
  },
];

export const resources = [
  {
    id: "res-001",
    title: "2024年最新考研数学全套复习资料包",
    categoryId: "xuexi-ziliao",
    categoryName: "学习资料",
    description: "包含高数、线代、概率论三科全套笔记、真题解析及模拟试卷，考研党必备资料合集。",
    image: "https://readdy.ai/api/search-image?query=Mathematics%20textbooks%20and%20exam%20papers%20neatly%20stacked%20on%20a%20clean%20white%20desk%2C%20warm%20natural%20light%2C%20minimalist%20cream%20background%2C%20editorial%20style%2C%20simple%20elegant%20composition&width=800&height=600&seq=res-001&orientation=landscape",
    date: "2024-12-15",
    views: 15820,
    downloads: 3621,
    featured: true,
    hot: true,
    tags: ["考研", "数学", "复习资料"],
    fileSize: "2.8GB",
    fileType: "PDF+视频",
  },
  {
    id: "res-002",
    title: "Adobe Photoshop 2024 中文精简版（Win/Mac）",
    categoryId: "gongju-ruanjian",
    categoryName: "工具软件",
    description: "最新版Photoshop中文精简版，已去除不需要组件，安装即用，附带详细安装教程。",
    image: "https://readdy.ai/api/search-image?query=Modern%20laptop%20displaying%20photo%20editing%20software%20interface%20on%20clean%20white%20desk%2C%20warm%20cream%20background%2C%20soft%20natural%20light%2C%20minimalist%20editorial%20style%2C%20clean%20composition&width=800&height=600&seq=res-002&orientation=landscape",
    date: "2024-12-10",
    views: 32500,
    downloads: 8930,
    featured: true,
    hot: true,
    tags: ["PS", "设计工具", "Adobe"],
    fileSize: "1.5GB",
    fileType: "软件安装包",
  },
  {
    id: "res-003",
    title: "1000+高清4K自然风光视频素材合集",
    categoryId: "yingyin-sucai",
    categoryName: "影音素材",
    description: "超清4K自然风光视频素材，包含山川、海洋、森林、星空等多种场景，适合视频创作使用。",
    image: "https://readdy.ai/api/search-image?query=Beautiful%20mountain%20lake%20landscape%20with%20reflection%2C%20cinematic%20style%2C%20clean%20clear%20composition%2C%20warm%20golden%20hour%20light%2C%20professional%20nature%20photography%2C%20soft%20atmospheric%20tones&width=800&height=600&seq=res-003&orientation=landscape",
    date: "2024-12-08",
    views: 21000,
    downloads: 5420,
    featured: true,
    hot: false,
    tags: ["4K", "视频素材", "自然风光"],
    fileSize: "32GB",
    fileType: "MP4视频",
  },
  {
    id: "res-004",
    title: "最新版UI设计规范与组件库（Figma+Sketch）",
    categoryId: "sheji-ziyuan",
    categoryName: "设计资源",
    description: "包含最新iOS/Android设计规范，200+组件模板，适配Figma和Sketch，即开即用。",
    image: "https://readdy.ai/api/search-image?query=Modern%20UI%20design%20mockups%20displayed%20on%20large%20monitor%20screen%2C%20clean%20minimalist%20workspace%2C%20warm%20cream%20background%2C%20soft%20natural%20lighting%2C%20editorial%20style%2C%20simple%20composition&width=800&height=600&seq=res-004&orientation=landscape",
    date: "2024-12-05",
    views: 18900,
    downloads: 4280,
    featured: false,
    hot: true,
    tags: ["UI设计", "组件库", "Figma"],
    fileSize: "850MB",
    fileType: "Figma+Sketch",
  },
  {
    id: "res-005",
    title: "Python编程从入门到精通完整教程（含源码）",
    categoryId: "xuexi-ziliao",
    categoryName: "学习资料",
    description: "零基础Python学习教程，包含视频讲解、实战项目源码、课后习题，助你快速掌握Python编程。",
    image: "https://readdy.ai/api/search-image?query=Clean%20code%20editor%20displaying%20Python%20code%20on%20laptop%20screen%2C%20warm%20white%20and%20cream%20background%2C%20soft%20natural%20light%2C%20minimalist%20editorial%20style%2C%20simple%20tech%20aesthetic&width=800&height=600&seq=res-005&orientation=landscape",
    date: "2024-12-01",
    views: 28600,
    downloads: 7640,
    featured: true,
    hot: true,
    tags: ["Python", "编程", "入门教程"],
    fileSize: "5.2GB",
    fileType: "视频+源码",
  },
  {
    id: "res-006",
    title: "2024年最新Office办公软件全套教程",
    categoryId: "shiyong-moban",
    categoryName: "实用模板",
    description: "Word、Excel、PPT三合一教程，从基础操作到高级技巧，配套练习文件，办公必备。",
    image: "https://readdy.ai/api/search-image?query=Office%20software%20tutorial%20books%20and%20laptop%20on%20clean%20white%20desk%2C%20warm%20cream%20background%2C%20soft%20natural%20lighting%2C%20minimalist%20editorial%20style%2C%20simple%20composition&width=800&height=600&seq=res-006&orientation=landscape",
    date: "2024-11-28",
    views: 14200,
    downloads: 3890,
    featured: false,
    hot: false,
    tags: ["Office", "办公", "教程"],
    fileSize: "3.5GB",
    fileType: "视频+文档",
  },
  {
    id: "res-007",
    title: "300本经典文学名著电子书合集（epub+mobi）",
    categoryId: "dianzi-shuji",
    categoryName: "电子书籍",
    description: "精选古今中外文学名著电子版，支持Kindle、手机等多设备阅读，排版精美，值得收藏。",
    image: "https://readdy.ai/api/search-image?query=Elegant%20e-reader%20displaying%20classic%20literature%20book%20cover%20on%20wooden%20table%2C%20warm%20cream%20background%2C%20soft%20natural%20light%2C%20minimalist%20editorial%20style%2C%20cozy%20reading%20atmosphere&width=800&height=600&seq=res-007&orientation=landscape",
    date: "2024-11-25",
    views: 23100,
    downloads: 6780,
    featured: false,
    hot: true,
    tags: ["电子书", "文学", "名著"],
    fileSize: "1.2GB",
    fileType: "epub+mobi",
  },
  {
    id: "res-008",
    title: "超实用PPT商务演示模板100套",
    categoryId: "shiyong-moban",
    categoryName: "实用模板",
    description: "100套精选商务风格PPT模板，涵盖工作总结、项目汇报、产品介绍等场景，直接套用。",
    image: "https://readdy.ai/api/search-image?query=Professional%20presentation%20slides%20displayed%20on%20monitor%20screen%2C%20clean%20modern%20office%20setting%2C%20warm%20cream%20background%2C%20soft%20lighting%2C%20minimalist%20editorial%20style%2C%20simple%20composition&width=800&height=600&seq=res-008&orientation=landscape",
    date: "2024-11-20",
    views: 16700,
    downloads: 5120,
    featured: false,
    hot: false,
    tags: ["PPT", "模板", "商务"],
    fileSize: "450MB",
    fileType: "PPTX",
  },
  {
    id: "res-009",
    title: "2024年考公行测申论全套备考资料",
    categoryId: "xuexi-ziliao",
    categoryName: "学习资料",
    description: "国考省考通用行测申论备考资源，含历年真题、名师讲解、时政热点，助力上岸。",
    image: "https://readdy.ai/api/search-image?query=Exam%20preparation%20books%20and%20highlighted%20notes%20on%20clean%20white%20desk%2C%20warm%20cream%20background%2C%20soft%20natural%20light%2C%20minimalist%20editorial%20style%2C%20simple%20composition&width=800&height=600&seq=res-009&orientation=landscape",
    date: "2024-11-15",
    views: 35200,
    downloads: 12050,
    featured: true,
    hot: true,
    tags: ["考公", "行测", "申论"],
    fileSize: "4.8GB",
    fileType: "PDF+视频",
  },
  {
    id: "res-010",
    title: "精品音效素材包：8000+无损音效合集",
    categoryId: "yingyin-sucai",
    categoryName: "影音素材",
    description: "涵盖环境音、转场音、UI交互音、乐器音等8000多种高品质音效，视频剪辑必备。",
    image: "https://readdy.ai/api/search-image?query=Professional%20audio%20mixing%20console%20with%20sound%20waveforms%20on%20screen%2C%20clean%20cream%20and%20white%20background%2C%20warm%20soft%20lighting%2C%20minimalist%20editorial%20style%2C%20simple%20composition&width=800&height=600&seq=res-010&orientation=landscape",
    date: "2024-11-10",
    views: 12300,
    downloads: 3450,
    featured: false,
    hot: false,
    tags: ["音效", "素材", "音频"],
    fileSize: "15GB",
    fileType: "WAV+MP3",
  },
];

export const articles = [
  {
    id: "art-001",
    resourceId: "res-001",
    title: "2024年最新考研数学全套复习资料包",
    categoryId: "xuexi-ziliao",
    categoryName: "学习资料",
    description: "包含高数、线代、概率论三科全套笔记、真题解析及模拟试卷，考研党必备资料合集。",
    image: "https://readdy.ai/api/search-image?query=Mathematics%20textbooks%20and%20exam%20papers%20neatly%20stacked%20on%20a%20clean%20white%20desk%2C%20warm%20natural%20light%2C%20minimalist%20cream%20background%2C%20editorial%20style%2C%20simple%20elegant%20composition&width=800&height=600&seq=art-001&orientation=landscape",
    date: "2024-12-15",
    views: 15820,
    downloads: 3621,
    tags: ["考研", "数学", "复习资料"],
    fileSize: "2.8GB",
    fileType: "PDF+视频",
    content: `## 资源简介

本资源包是2024年最新考研数学全套复习资料，涵盖高等数学、线性代数、概率论与数理统计三大科目。资料由多位考研数学名师联合整理，内容全面、体系完整，适合基础阶段至冲刺阶段的全流程复习。

## 资源内容

### 一、高等数学部分
- **基础精讲笔记**：涵盖函数极限、导数与微分、积分学、微分方程等全部章节的详细笔记，附带经典例题解析
- **真题分类汇编**：近10年考研数学一、二、三真题按章节分类整理，每道题目配有详细解答过程
- **高频考点总结**：提炼历年考试高频考点，重点标注易错点和解题技巧
- **模拟试卷**：10套高质量模拟试卷，难度贴近真题，附参考答案与评分标准

### 二、线性代数部分
- **知识框架图**：以思维导图形式梳理线代知识体系，帮助建立整体认知
- **核心定理证明**：所有重要定理的完整证明过程，加深理解
- **典型题型精讲**：分题型整理经典题目，包含行列式、矩阵、向量组、方程组等核心模块
- **冲刺速记手册**：考前快速回顾的速记卡片，浓缩全书精华

### 三、概率论与数理统计部分
- **概念解析笔记**：对概率论中易混淆的概念进行对比分析，清晰明了
- **公式大全**：所有概率统计公式的完整汇总，方便查阅
- **应用题专项训练**：针对考试中的应用题类型进行专项突破
- **历年真题详解**：精讲近5年概率统计真题，揭示命题规律

## 适用人群
- 备战2024年考研数学的考生
- 需要系统复习数学基础的同学
- 希望通过刷题提升解题能力的考研党

## 使用建议
1. 建议按照高数 → 线代 → 概率论的顺序进行系统复习
2. 每学完一章，及时完成对应的真题练习
3. 利用高频考点总结进行定期回顾
4. 考前一个月集中使用模拟试卷进行实战演练`,
  },
  {
    id: "art-002",
    resourceId: "res-005",
    title: "Python编程从入门到精通完整教程（含源码）",
    categoryId: "xuexi-ziliao",
    categoryName: "学习资料",
    description: "零基础Python学习教程，包含视频讲解、实战项目源码、课后习题，助你快速掌握Python编程。",
    image: "https://readdy.ai/api/search-image?query=Clean%20code%20editor%20displaying%20Python%20code%20on%20laptop%20screen%2C%20warm%20white%20and%20cream%20background%2C%20soft%20natural%20light%2C%20minimalist%20editorial%20style%2C%20simple%20tech%20aesthetic&width=800&height=600&seq=art-002&orientation=landscape",
    date: "2024-12-01",
    views: 28600,
    downloads: 7640,
    tags: ["Python", "编程", "入门教程"],
    fileSize: "5.2GB",
    fileType: "视频+源码",
    content: `## 教程简介

本教程是一套完整的Python编程学习资源，从零基础讲起，循序渐进带你掌握Python编程的核心技能。教程由资深Python开发工程师录制，结合多年实战经验，确保内容的实用性和前沿性。

## 教程目录

### 第一阶段：Python基础入门
- Python环境搭建与开发工具配置
- 变量、数据类型与运算符
- 流程控制：条件判断与循环
- 函数定义与模块化编程
- 容器类型：列表、元组、字典、集合
- 字符串处理与正则表达式

### 第二阶段：Python进阶提升
- 面向对象编程（OOP）：类与对象、继承与多态
- 文件操作与异常处理
- 迭代器、生成器与装饰器
- 常用标准库详解
- 虚拟环境与包管理

### 第三阶段：实战项目
- 项目一：自动化办公脚本（批量处理Excel/Word/PDF）
- 项目二：Web爬虫实战（数据采集与分析）
- 项目三：Web开发入门（Flask框架搭建个人博客）
- 项目四：数据分析可视化（Pandas+Matplotlib）
- 项目五：GUI桌面应用开发（Tkinter）

### 第四阶段：面试与进阶
- Python常见面试题精讲
- 算法与数据结构基础
- 代码规范与最佳实践
- 学习路线与资源推荐

## 配套资源
- 全套高清视频教程（MP4格式）
- 所有案例完整源代码
- 课后习题与参考答案
- 学习路线图与进度表

## 适合人群
- 零基础想学编程的新手
- 转行从事Python开发的学习者
- 需要Python技能的办公人员
- 准备Python面试的求职者`,
  },
  {
    id: "art-003",
    resourceId: "res-009",
    title: "2024年考公行测申论全套备考资料",
    categoryId: "xuexi-ziliao",
    categoryName: "学习资料",
    description: "国考省考通用行测申论备考资源，含历年真题、名师讲解、时政热点，助力上岸。",
    image: "https://readdy.ai/api/search-image?query=Exam%20preparation%20books%20and%20highlighted%20notes%20on%20clean%20white%20desk%2C%20warm%20cream%20background%2C%20soft%20natural%20light%2C%20minimalist%20editorial%20style%2C%20simple%20composition&width=800&height=600&seq=art-003&orientation=landscape",
    date: "2024-11-15",
    views: 35200,
    downloads: 12050,
    tags: ["考公", "行测", "申论"],
    fileSize: "4.8GB",
    fileType: "PDF+视频",
    content: `## 资料简介

本套资料是2024年最新版公务员考试备考资料，涵盖行政职业能力测验（行测）和申论两大科目。资料由多位公考名师精心整理，内容紧跟最新考试大纲，是考公路上的强力助推器。

## 资料内容

### 行测部分
- **言语理解与表达**：逻辑填空、阅读理解、语句表达三大题型专项突破，附高频成语辨析与实词搭配手册
- **数量关系**：数学运算题型分类精讲，包含工程问题、行程问题、排列组合等常考题型，提供速算技巧与秒杀方法
- **判断推理**：图形推理、定义判断、类比推理、逻辑判断四大模块详解，配有思维导图辅助记忆
- **资料分析**：速算技巧大全，增长率、比重、倍数等核心概念深度解析，真题实战演练
- **常识判断**：政治、经济、法律、文史、科技等常识考点汇总，重点标注高频考点

### 申论部分
- **阅读理解技法**：如何快速准确提取材料要点，概括归纳的核心方法
- **综合分析题型**：词句理解、观点评价、现象分析等题型的答题框架
- **提出对策技巧**：问题识别与对策提出的方法论，模板化答题思路
- **大作文写作**：议论文写作框架、素材积累、论证方法、高分范文赏析

### 增值内容
- 近5年国考+省考真题汇总（含详细解析）
- 时政热点月度汇编
- 申论高分范文100篇
- 行测高频考点速记手册

## 使用建议
1. 行测学习按照模块逐个突破，先易后难
2. 申论学习中多读多练，注重素材积累
3. 每周至少完成一套完整真题模拟
4. 考前重点回顾高频考点和易错题目`,
  },
  {
    id: "art-004",
    resourceId: "res-002",
    title: "Adobe Photoshop 2024 中文精简版（Win/Mac）",
    categoryId: "gongju-ruanjian",
    categoryName: "工具软件",
    description: "最新版Photoshop中文精简版，已去除不需要组件，安装即用，附带详细安装教程。",
    image: "https://readdy.ai/api/search-image?query=Modern%20laptop%20displaying%20photo%20editing%20software%20interface%20on%20clean%20white%20desk%2C%20warm%20cream%20background%2C%20soft%20natural%20light%2C%20minimalist%20editorial%20style%2C%20clean%20composition&width=800&height=600&seq=art-004&orientation=landscape",
    date: "2024-12-10",
    views: 32500,
    downloads: 8930,
    tags: ["PS", "设计工具", "Adobe"],
    fileSize: "1.5GB",
    fileType: "软件安装包",
    content: `## 软件介绍

Adobe Photoshop 2024 是Adobe公司推出的专业图像处理软件，本版本为中文精简优化版，已去除不需要的组件和插件，保留了核心图像处理功能，安装更加快速便捷。支持Windows和macOS双平台。

## 版本特点

### 精简优化
- 移除非必要的云服务组件，减少系统资源占用
- 精简语言包，仅保留简体中文
- 优化启动速度，提升软件响应效率
- 保留全部核心图像处理功能

### 新增功能
- **AI智能选区**：利用Adobe Sensei AI技术，一键精准抠图
- **神经滤镜**：智能肖像调整、风格迁移等AI功能
- **天空替换**：一键替换照片中的天空背景
- **内容识别填充增强**：更自然的内容感知填充效果
- **图案预览**：实时预览图案填充效果

### 系统要求
- **Windows**：Windows 10/11 64位，8GB以上内存，4GB可用硬盘空间
- **macOS**：macOS 12.0及以上，Apple Silicon原生支持，8GB以上内存

## 安装步骤

### Windows安装
1. 下载安装包并解压
2. 断开网络连接（重要）
3. 以管理员身份运行安装程序
4. 按照安装向导完成安装
5. 运行激活工具完成激活

### macOS安装
1. 下载DMG安装镜像
2. 打开系统偏好设置 → 安全性与隐私
3. 允许来自任何来源的应用程序
4. 拖拽应用到Applications文件夹
5. 运行激活补丁

## 注意事项
- 安装前请关闭杀毒软件，避免误删文件
- 建议在断网环境下完成安装
- 如遇到问题，请参考安装包内的常见问题文档
- 本资源仅供学习交流使用`,
  },
];

export const faqItems = [
  {
    question: "老六资源库的资源都是免费的吗？",
    answer: "是的，老六资源库所有资源完全免费提供。我们致力于打造一个开放共享的资源平台，让每个人都能轻松获取优质学习资料和实用工具，无需支付任何费用。",
  },
  {
    question: "资源的下载方式是什么？",
    answer: "大部分资源通过百度网盘或阿里云盘分享，点击资源详情页的下载按钮即可获取链接和提取码。部分小文件也提供直接下载链接，方便快捷。",
  },
  {
    question: "资源多久更新一次？",
    answer: "我们保持每周至少3-5次更新频率，确保资源库内容持续丰富。关注首页「最新资源」板块，可以第一时间获取新上线的资源内容。",
  },
  {
    question: "如何快速找到我需要的资源？",
    answer: "你可以通过首页的分类导航浏览不同类别的资源，也可以使用搜索功能输入关键词快速定位。每个资源都有详细的标签和描述信息，帮助你判断是否符合需求。",
  },
  {
    question: "下载链接失效了怎么办？",
    answer: "如果遇到下载链接失效的情况，请在资源详情页面的反馈区留言说明，我们会尽快修复并更新链接。同时你也可以通过「关于我们」页面的联系方式直接反馈给我们。",
  },
  {
    question: "可以推荐或投稿资源吗？",
    answer: "当然可以！我们非常欢迎用户推荐优质资源。你可以通过「关于我们」页面的联系方式提交资源推荐，审核通过后我们会添加到资源库中，并标注推荐者信息。",
  },
];

export const statsData = [
  { label: "资源总数", value: "11,200+", icon: "ri-database-2-line" },
  { label: "资源分类", value: "30+", icon: "ri-folder-2-line" },
  { label: "累计下载", value: "58万+", icon: "ri-download-2-line" },
  { label: "活跃用户", value: "9.6万+", icon: "ri-user-smile-line" },
];

export const featuresData = [
  {
    icon: "ri-shield-check-line",
    title: "安全可靠",
    description: "所有资源经过人工审核，确保内容安全无病毒，让你放心下载使用。",
  },
  {
    icon: "ri-refresh-line",
    title: "持续更新",
    description: "资源库保持高频更新，第一时间收录最新优质资源，永不过时。",
  },
  {
    icon: "ri-price-tag-3-line",
    title: "完全免费",
    description: "所有资源免费下载，无隐藏收费，致力于打造开放的资源共享社区。",
  },
  {
    icon: "ri-group-line",
    title: "社区共建",
    description: "用户可推荐优质资源，经审核后纳入资源库，实现社区共建共享。",
  },
  {
    icon: "ri-search-eye-line",
    title: "精准搜索",
    description: "多维度分类与标签系统，配合智能搜索，帮你快速找到所需资源。",
  },
  {
    icon: "ri-thumb-up-line",
    title: "品质保障",
    description: "严格筛选资源质量，只收录经过验证的优质内容，拒绝低质资源。",
  },
];

export const testimonials = [
  {
    name: "小明同学",
    role: "考研备考生",
    avatar: "https://readdy.ai/api/search-image?query=Young%20Chinese%20student%20portrait%2C%20friendly%20smile%2C%20clean%20cream%20background%2C%20soft%20lighting%2C%20professional%20headshot%2C%20simple%20composition&width=200&height=200&seq=avatar-01&orientation=squarish",
    content: "老六资源库真的太棒了！考研资料应有尽有，省去了我大量搜集资料的时间，强烈推荐给所有考研党！",
  },
  {
    name: "设计师阿杰",
    role: "自由设计师",
    avatar: "https://readdy.ai/api/search-image?query=Professional%20Asian%20creative%20designer%20portrait%2C%20confident%20expression%2C%20clean%20cream%20background%2C%20soft%20studio%20lighting%2C%20modern%20headshot%2C%20simple%20composition&width=200&height=200&seq=avatar-02&orientation=squarish",
    content: "这里的设计资源非常丰富，UI模板、图标、字体应有尽有，而且全部免费，设计师的宝藏网站！",
  },
  {
    name: "程序员老王",
    role: "后端开发工程师",
    avatar: "https://readdy.ai/api/search-image?query=Asian%20tech%20professional%20with%20glasses%20portrait%2C%20friendly%20smile%2C%20clean%20cream%20background%2C%20soft%20lighting%2C%20professional%20headshot%2C%20simple%20composition&width=200&height=200&seq=avatar-03&orientation=squarish",
    content: "各种开发工具和教程应有尽有，还都是免费的。老六资源库是我见过最良心的资源分享平台！",
  },
];